export function useUiBlockingGate() {
  const overlay = useOverlay();
  const ui = useCirrusReaderUiStore();

  const hasOpenDrawer = computed(
    () => ui.leftDrawerOpen || ui.rightDrawerOpen
  );

  const hasOpenOverlay = computed(() =>
    overlay.overlays.some((o) => o.isOpen)
  );

  const hasOpenBottomMenu = computed(
    () => ui.bottomDrawerOpen
  );

  const isUiBlocking = computed(
    () => hasOpenDrawer.value || hasOpenOverlay.value
  );

  const closeAll = () => {
    ui.toggleLeftDrawer(false);
    ui.toggleRightDrawer(false);
    overlay.closeAll();
  }

  return {
    hasOpenDrawer,
    hasOpenOverlay,
    hasOpenBottomMenu,
    isUiBlocking,
    closeAll
  };
}
